<template>
  <div class="sharing-container">
    <SharingList
      :article="article"
      :shown="shown"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { IFullArticle, TArticle } from '~/types/common';
  import SharingList from '~/components/Sharing/SharingList.vue';
  export default defineNuxtComponent({
    name: 'SharingDesktop',
    components: { SharingList },

    props: {
      article: {
        type: Object as PropType<TArticle | IFullArticle>,
        required: true,
      },

      shown: {
        type: Boolean as PropType<boolean>,
        required: false,
        default: null,
      },
    },
  });
</script>

<style lang="scss" scoped>
  .sharing-container {
    background: #ffffff;
    border: 4px solid #000000;
    border-radius: 32px;
    box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.05);
    padding: $spacing-4 0 21px;
    min-width: 320px;
    overflow: hidden;
  }
</style>
